<template>
    <div>
        <div
            class="container-fluid"
            v-if="showLabels && !bSmallScreen "
            :style="{ 
                position: 'fixed',
                top: '8vh',
                width: '100vw',
                zIndex: 10,
                pointerEvents: 'none'
            }"
        >
            <div 
                :style="{ 
                    zIndex: 10,
                }"
                v-for="(item, index) in galleryText"
                :key="item.label"
                >
                <div v-if="index==0" class="row justify-content-left text-left m-2 mb-4">
                    <div class="col-4 text-left align-bottom">
                        <h1 class="gallery-title-text">{{galleryText[index]}}</h1>
                    </div>
                </div>
                <div v-else class="row justify-content-left ml-2 mb-0 text-left">
                    <div v-if="index==1" class="col-4 text-left mb-0">
                        <h6 class="gallery-subtitle-text">{{galleryText[index]}}</h6>
                    </div>
                    <div v-else class="col-4 text-left indent mt-0">
                        <h6 class="gallery-subtitle-text indent">{{galleryText[index]}}</h6>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="container-fluid"
            v-if="showLabels && bSmallScreen"
            :style="{ 
                position: 'fixed',
                top: '8vh',
                width: '100vw',
                cursor: 'url(' + clickCursor + '), auto',
                zIndex: 10,
            }"
        >
            
            <div 
                :style="{ 
                    zIndex: 10,
                }"

                v-for="(item, index) in galleryText"
                :key="item.label"
                >
                <div v-if="index==0" class="row justify-content-left text-left ml-auto mb-4">
                    <div class="col-9 text-left align-bottom">
                        <h1 class="gallery-title-text">{{galleryText[index]}}</h1>
                    </div>
                </div>
                <div v-else class="row justify-content-left ml-auto mb-0 text-left">
                    <div v-if="index==1" class="col-9 text-left mb-0">
                        <h6 class="gallery-subtitle-text">{{galleryText[index]}}</h6>
                    </div>
                    <div v-else class="col-9 text-left indent mt-0">
                        <h6 class="gallery-subtitle-text indent">{{galleryText[index]}}</h6>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="container-fluid label-view-overlay"
            v-if="showLabels"
            :style="{ 
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100vw',
                height: '100vh',
                cursor: 'url(' + pointerCursor + '), auto',
                zIndex: 5,
            }"
            @click="setLabelsVisible(false)"
        >
        </div>
        <footer class="footer" style="width: 100%;">
            <div class="row justify-content-between m-3 fixed-bottom">
                <div class="col-6 text-left align-items-end">
                    <h2 
                        class="gallery-title align-self-end"
                        @mouseover="toggleGalleryText()"
                        @mouseleave="toggleGalleryText()"
                        >
                            {{gallery}}
                    </h2>
                </div>
                <div v-if="!hideEye" class="col-6 text-right align-self-end">
                    <img
                        class="align-bottom img-fluid"
                        :src="curEye"
                        v-if="!showLabels"
                        @click=setLabelsVisible(true) 
                        @mouseover=fillEye(true) 
                        @mouseleave=fillEye(false) 
                        :style="{ 
                            maxHeight: '100%',
                            cursor: 'url(' + clickCursor + '), auto'
                        }"
                    >
                    <img
                        class="align-bottom img-fluid"
                        :src="eyesel"
                        v-if="showLabels"
                        @click=setLabelsVisible(false) 
                        :style="{ 
                            maxHeight: '100%',
                            cursor: 'url(' + clickCursor + '), auto'
                        }"
                    >
                </div>
            </div>
        </footer>
    </div>
    
</template>

<script>
import { bus } from '../main';
export default {
  name: "Footer",
  props: ["gallery", "galleryText", "hideEye"],
  data: function() {
    return {
        eye: require('@/assets/icons/eye.png'),
        eyesel: require('@/assets/icons/eyesel.png'),
        eyeBlink: require('@/assets/icons/eyeBlink.png'),
        showLabels: false,
        showGalleryText: false,
        pointerCursor: require('@/assets/cursors/magnify.svg'),
        clickCursor: require('@/assets/cursors/pointer.svg'),
        curEye: require('@/assets/icons/eye.png'),
        lightboxVisible: false,
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth,
        bSmallScreen: false,
    }
  },
  computed: {
  },
  methods: {
      setLabelsVisible(bVisible) {
          this.showLabels = bVisible;
          this.$emit('show', bVisible);
          this.fillEye(false);
      },
      fillEye: function(arg) {
          this.curEye = (arg) ? this.eyesel : this.eye;
      },
      blinkEye: function(arg) {
          this.curEye = (arg) ? this.eyeBlink : this.eye;
      },
      toggleGalleryText() {
          if (!this.lightboxVisible) {
            this.showGalleryText = !this.showGalleryText;
          }   
      },
      onMaskHovered() {
        this.blinkEye(true);
        },
        onMaskLeft() {
            this.blinkEye(false);
        },
      onResize() {
        this.windowHeight = window.innerHeight;
        this.windowWidth = window.innerWidth;
        if (this.windowWidth<1100 || this.windowHeight<700) {
            this.bSmallScreen = true;
        }
        else {
            this.bSmallScreen = false;
        }
    },
  },
  created() {
    window.addEventListener("resize", this.onResize);

    bus.$on('overMask', () => {
        this.onMaskHovered();
    });

    bus.$on('leaveMask', () => {
        this.onMaskLeft();
    });

    this.onResize();
  },
  destroyed() {
      window.removeEventListener("resize", this.onResize);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .footer {
        position: fixed;
        bottom: 8vh;
        margin: 40px 10px 0;
        z-index: 50;
    }

    /* .gallery-title:hover {
        font-weight: 800;
        text-decoration: none;
        cursor: url('../assets/cursors/magnify.svg'), auto;
    } */

    @media screen and (min-width: 601px) {
        .gallery-title {
            font-size: 3vh;
        };
    }

    @media screen and (max-width: 601px) {
        .gallery-title {
            font-size: 1.6rem;
        };
    }

    @media screen and (min-width: 601px) {
        .gallery-title-text {
            font-size: 2rem;
        };
    }

    @media screen and (max-width: 601px) {
        .gallery-title-text {
            font-size: 1.6rem;
        };
    }

    @media screen and (min-width: 601px) {
        h6.gallery-subtitle-text {
            font-size: 1.5rem;
        }
    }

    @media screen and (max-width: 700px) {
        h6.gallery-subtitle-text {
            font-size: 3vw;
        }
    }

    .indent {
        text-indent: 2rem;
    }

    

</style>